import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Punetonashikcabservice() {



const cardData =
{
  keyword: 'Pune to Nashik Cab Service',

  heading: 'Lotus Cab: Pune to Nashik Cab Service',

headingDescription:
    "Lotus Cabs offers reliable and affordable Pune to Nashik Cab Service for business travel, family vacations, pilgrimage tours, corporate trips, wine tourism, airport transfers, and one-way or round-trip journeys. Our fleet includes Sedan, SUV, Innova Crysta, Ertiga, Kia Carens, Tempo Traveller, Luxury Urbania, and Mini Bus, driven by professional and experienced chauffeurs to ensure a safe and comfortable ride. With 24x7 booking support, transparent pricing, doorstep pickup anywhere in Pune, well-maintained vehicles, and convenient highway travel, Lotus Cabs delivers a hassle-free journey to Nashik and its renowned religious, historical, and tourist attractions.",

  top: 'Top Places to Visit in Nashik with Lotus Cab',

 topPlaces: [
    {
        title: "Trimbakeshwar Jyotirlinga",
        description:
            "Trimbakeshwar Jyotirlinga is one of the twelve sacred Jyotirlingas of Lord Shiva and one of Maharashtra's most important pilgrimage destinations. Located at the foothills of Brahmagiri Hills, the temple is renowned for its unique three-faced Jyotirlinga, sacred Kushavarta Kund, and religious rituals such as Narayan Nagbali and Kalsarp Dosh Puja. Devotees from Pune visit throughout the year to seek divine blessings and spiritual peace."
    },
    {
        title: "Panchavati",
        description:
            "Panchavati is a sacred area closely associated with the Ramayana and is one of the most visited religious destinations in Nashik. Pilgrims explore famous sites including Ram Kund, Kalaram Temple, Sita Gufa, and the Godavari Ghats, making Panchavati an essential stop during every spiritual journey to Nashik."
    },
    {
        title: "Sula Vineyards",
        description:
            "Sula Vineyards is India's most celebrated wine tourism destination, offering vineyard tours, premium wine tasting experiences, gourmet dining, and scenic countryside views. Families, couples, and corporate travelers from Pune frequently include Sula Vineyards in their itinerary for a relaxing and memorable getaway."
    },
    {
        title: "Anjaneri Hills",
        description:
            "Anjaneri Hills, believed to be the birthplace of Lord Hanuman, are a popular destination for pilgrims, trekkers, and nature lovers. The hills offer beautiful trekking trails, panoramic mountain views, ancient temples, and peaceful surroundings, making them a perfect combination of spirituality and adventure."
    },
    {
        title: "Ram Kund",
        description:
            "Ram Kund is one of the holiest bathing ghats on the banks of the Godavari River and holds immense religious significance for Hindus. Devotees perform sacred rituals, prayers, and ancestral ceremonies here, especially during festivals and the grand Kumbh Mela celebrated in Nashik."
    },
    {
        title: "Coin Museum",
        description:
            "The Indian Institute of Research in Numismatic Studies houses the famous Coin Museum, showcasing an extensive collection of ancient and modern Indian coins, currency, and historical artifacts. It is a fascinating destination for history enthusiasts, students, and visitors interested in India's rich monetary heritage."
    },
    {
        title: "Gangapur Dam",
        description:
            "Gangapur Dam is a picturesque destination on the outskirts of Nashik, offering peaceful surroundings, scenic reservoir views, and spectacular sunsets. It is a popular spot for families, photographers, and travelers looking to relax amidst nature after exploring the city's religious attractions."
    },
    {
        title: "Muktidham Temple",
        description:
            "Muktidham Temple is a beautiful white marble temple complex dedicated to various Hindu deities and features replicas of all twelve Jyotirlingas. Its elegant architecture, spiritual atmosphere, and convenient location make it a popular stop for pilgrims and tourists visiting Nashik."
    },
    {
        title: "Pandavleni Caves",
        description:
            "Pandavleni Caves are ancient Buddhist rock-cut caves dating back over two thousand years and are renowned for their intricate carvings, inscriptions, meditation chambers, and panoramic views of Nashik city. The site attracts history lovers, trekkers, and photographers throughout the year."
    },
    {
        title: "Harihar Fort",
        description:
            "Harihar Fort is one of Maharashtra's most famous trekking destinations, known for its iconic rock-cut staircase, breathtaking summit views, and historic fortifications. Adventure enthusiasts traveling from Pune often combine a Nashik trip with a visit to Harihar Fort for an unforgettable trekking and sightseeing experience."
    }
],

  "services": [
    {
      "name": "Pune to Nashik Cab Service",
      "description": "Book Pune to Nashik cab service covering approximately 210 km via NH60 highway with smooth and safe intercity travel. Available for one-way drop, round trip, and multi-day tours. AC sedan, SUV, Ertiga, and Innova Crysta options ensure comfort based on group size. Transparent per kilometer pricing includes base fare, driver allowance, and toll details. Ideal for pilgrimage to Trimbakeshwar, wine tourism visits, business travel, and family vacations."
    },
    {
      "name": "Pune to Nashik Taxi Fare",
      "description": "Check updated Pune to Nashik taxi fare calculated on per km basis with minimum daily usage criteria. Fare varies depending on sedan or SUV category and travel duration. Clear billing breakdown eliminates hidden charges and ensures fare transparency. Suitable for both budget and premium travel planning."
    },
    {
      "name": "One Way Cab Pune to Nashik",
      "description": "Affordable one way cab Pune to Nashik option for passengers not returning the same day. Pay only for single-side distance without round-trip charges. Ideal for business transfers, airport drops, and extended stays. Professional drivers ensure comfortable highway journey."
    },
    {
      "name": "Pune to Nashik Round Trip Taxi",
      "description": "Round trip taxi service from Pune to Nashik allows flexible return timing for temple visits and vineyard tours. Multi-day rental plans reduce travel stress and provide relaxed sightseeing. Suitable for families and pilgrimage groups."
    },
    {
      "name": "Pune Airport to Nashik Cab",
      "description": "Direct Pune Airport to Nashik cab service for passengers arriving by flight. Timely pickup, luggage assistance, and immediate departure ensure smooth intercity travel. Suitable for corporate and tourist travelers."
    },
    {
      "name": "Pune to Nashik Cab Booking Online",
      "description": "Convenient Pune to Nashik cab booking online with instant confirmation and fare estimation. Choose preferred vehicle category and pickup location within Pune or PCMC area."
    },
    {
      "name": "Pune to Nashik Cab Price",
      "description": "Get clear Pune to Nashik cab price estimate based on distance, vehicle category, and trip type. Transparent fare structure helps plan travel budget effectively."
    },
    {
      "name": "Cheap Pune to Nashik Cab",
      "description": "Budget-friendly Pune to Nashik cab options available without compromising comfort or safety. Suitable for students, small families, and cost-conscious travelers seeking economical intercity travel."
    }
  ],

  "tableData": [
    ["Pune to Nashik Cab Service", "Pune to Nashik Taxi Fare"],
    ["One Way Cab Pune to Nashik", "Pune to Nashik Round Trip Taxi"],
    ["Pune Airport to Nashik Cab", "Pune to Nashik Cab Booking Online"],
    ["Pune to Nashik Cab Price", "Cheap Pune to Nashik Cab"]
  ],

  "whychoose": [
    {
      "WhyChooseheading": "Reliable Intercity Highway Travel",
      "WhyChoosedescription": "Experienced drivers ensure safe and smooth travel between Pune and Nashik."
    },
    {
      "WhyChooseheading": "Transparent Per Kilometer Pricing",
      "WhyChoosedescription": "Clear fare breakdown including tolls and driver allowance with no hidden charges."
    },
    {
      "WhyChooseheading": "One Way & Round Trip Flexibility",
      "WhyChoosedescription": "Flexible booking options suitable for pilgrimage, tourism, and business travel."
    },
    {
      "WhyChooseheading": "Multiple Vehicle Options",
      "WhyChoosedescription": "Sedan, SUV, Ertiga, and Innova Crysta options available based on group size."
    },
    {
      "WhyChooseheading": "Airport Pickup Available",
      "WhyChoosedescription": "Direct Pune Airport to Nashik cab service with timely departure."
    },
    {
      "WhyChooseheading": "Comfortable AC Vehicles",
      "WhyChoosedescription": "Well-maintained vehicles ensure comfortable long-distance travel."
    },
    {
      "WhyChooseheading": "Ideal for Pilgrimage & Tourism",
      "WhyChoosedescription": "Perfect for Trimbakeshwar darshan, vineyard tours, and family vacations."
    },
    {
      "WhyChooseheading": "24/7 Booking Support",
      "WhyChoosedescription": "Round-the-clock assistance for booking confirmation and fare inquiries."
    }
  ]
}





const faqData = [
  {
    question: 'Does Lotus Cab provide Pune to Nashik cab service?',
    answer: 'Yes, Lotus Cab offers reliable Pune to Nashik cab service for one-way and round trips with professional drivers and well-maintained vehicles for comfortable long-distance travel.',
  },
  {
    question: 'What is the distance between Pune and Nashik by cab?',
    answer: 'The distance from Pune to Nashik is approximately 210–220 km depending on the route. Travel time usually takes around 4 to 5 hours.',
  },
  {
    question: 'What are the charges for Pune to Nashik cab booking?',
    answer: 'Cab charges depend on vehicle type, trip type (one-way or round trip), and travel date. Lotus Cab provides transparent per km pricing with no hidden charges.',
  },
  {
    question: 'Can I book a one-way Pune to Nashik cab?',
    answer: 'Yes, Lotus Cab offers affordable one-way cab services from Pune to Nashik so customers only pay for the drop without return fare.',
  },
  {
    question: 'Which vehicles are available for Pune to Nashik travel?',
    answer: 'We provide Sedan cars like Dzire and Etios for small groups and SUVs like Ertiga and Innova Crysta for families and larger groups.',
  },
  {
    question: 'Do you provide cab service for Trimbakeshwar from Nashik?',
    answer: 'Yes, Lotus Cab offers extended trips from Nashik to Trimbakeshwar Temple and other nearby pilgrimage and tourist destinations.',
  },
  {
    question: 'Are toll and parking charges included in Pune to Nashik cab fare?',
    answer: 'Toll, parking, and state taxes are charged separately as per actuals. Lotus Cab maintains complete pricing transparency before booking confirmation.',
  },
  {
    question: 'Is Pune to Nashik cab service suitable for corporate travel?',
    answer: 'Yes, we provide punctual and comfortable cab services for corporate and business travel between Pune and Nashik.',
  },
  {
    question: 'Can I book a round trip from Pune to Nashik for 2 days?',
    answer: 'Absolutely. Lotus Cab offers flexible multi-day round trip packages for temple visits, wine tours, family trips, and business travel.',
  },
  {
    question: 'How can I book Pune to Nashik cab service with Lotus Cab?',
    answer: 'You can book by sharing your pickup location, travel date, passenger count, and vehicle preference to receive instant fare details and booking confirmation.',
  }
];

const testimonials = [
  {
    id: 1,
    name: 'Mr. Ajinkya Patil',
    feedback: 'Booked Lotus Cab for Pune to Nashik temple visit. Smooth ride, polite driver, and reasonable pricing. Very satisfied with the service.',
    rating: 5,
  },
  {
    id: 2,
    name: 'Mrs. Shweta Kulkarni',
    feedback: 'Excellent cab service from Pune to Nashik. Clean Innova, on-time pickup, and transparent fare. Highly recommend Lotus Cab.',
    rating: 5,
  },
];








































































const Images = [
  { place: "/images/keyword/1.jpg", text: "Pune Taxi Fare", link: "Pune-Taxi-Fare" },
  { place: "/images/keyword/2.jpg", text: "Pune Outstation Taxi Hire", link: "Pune-Outstation-Taxi-Hire" },
  { place: "/images/keyword/3.jpg", text: "Pimpri Chinchwad Online Cab", link: "Pimpri-Chinchwad-Online-Cab" },
  { place: "/images/keyword/4.jpg", text: "Best Cab Service in Pune", link: "Best-Cab-Service-in-Pune" },
  { place: "/images/keyword/5.jpg", text: "Pune to Mumbai One Way Cabs", link: "Pune-to-Mumbai-One-Way-Cabs" },
  { place: "/images/keyword/6.jpg", text: "Pune to Nasik Cabs", link: "Pune-to-Nasik-Cabs" },
  { place: "/images/keyword/7.jpg", text: "Pune to Mahabaleshwar Cabs", link: "Pune-to-Mahabaleshwar-Cabs" },
  { place: "/images/keyword/8.jpg", text: "Pune to Lonavala Cab Booking", link: "Pune-to-Lonavala-Cab-Booking" },
  { place: "/images/keyword/9.jpg", text: "Pune to Shirdi Cabs", link: "Pune-to-Shirdi-Cabs" },
  { place: "/images/keyword/10.jpg", text: "Pune to Lavasa City Cabs", link: "Pune-to-Lavasa-City-Cabs" },
  { place: "/images/keyword/11.jpg", text: "Pune Airport to Bhimashankar Cabs", link: "Pune-Airport-to-Bhimashankar-Cabs" },
  { place: "/images/keyword/12.jpg", text: "Pune to Indore Cabs", link: "Pune-to-Indore-Cabs" },
  { place: "/images/keyword/13.jpg", text: "Pune to Konkan Darshan Cabs", link: "Pune-to-Konkan-Darshan-Cabs" },
  { place: "/images/keyword/14.jpg", text: "Pune Cab Fare", link: "Pune-Cab-Fare" },
  { place: "/images/keyword/15.jpg", text: "Outstation Taxi Service Pune", link: "Outstation-Taxi-Service-Pune" },
  { place: "/images/keyword/16.jpg", text: "Pune to Panchgani Cab Booking", link: "Pune-to-Panchgani-Cab-Booking" },
  { place: "/images/keyword/17.jpg", text: "Pune to Mumbai International Airport Taxi", link: "Pune-to-Mumbai-International-Airport-Taxi" },
  { place: "/images/keyword/18.jpg", text: "Ashtavinayak Darshan Cab Package", link: "Ashtavinayak-Darshan-Cab-Package" },
  { place: "/images/keyword/19.jpg", text: "Pune To Nagpur Cabs", link: "Pune-To-Nagpur-Cabs" },
  { place: "/images/keyword/20.jpg", text: "Cab Service in Kharadi", link: "Cab-Service-in-Kharadi" },
  { place: "/images/keyword/21.jpg", text: "Taxi Service in Hinjewadi Pune", link: "Taxi-Service-in-Hinjewadi-Pune" },
  { place: "/images/keyword/22.jpg", text: "Pune to Gujarat Cab Service", link: "Pune-to-Gujarat-Cab-Service" },
  { place: "/images/keyword/23.jpg", text: "Travel Agents in Pune", link: "Travel-Agents-in-Pune" },
  { place: "/images/keyword/24.jpg", text: "Pune to Thane Cab", link: "Pune-to-Thane-Cab" },
  { place: "/images/keyword/25.jpg", text: "Pune to Bangalore Taxi Service", link: "Pune-to-Bangalore-Taxi-Service" },

];








const productSchema = {
"@context": "https://schema.org",
"@type": "Product",
"name": "Pune to Nashik Cab Service",
"image": "https://lotuscab.com/assets/images/pune-to-nashik-cab-service.jpg",
"description": "Book Pune to Nashik Cab Service with Lotus Cab for safe, comfortable, and affordable intercity travel. One way and round trip taxi service with Sedan, SUV, and AC cabs available 24x7 with instant booking confirmation.",
"brand": {
"@type": "Brand",
"name": "Lotus Cab"
},
"aggregateRating": {
"@type": "AggregateRating",
"bestRating": "5",
"worstRating": "1",
"ratingValue": "4.8",
"ratingCount": "6673"
},
"offers": {
"@type": "Offer",
"priceCurrency": "INR",
"price": "Starting From ₹11/Km",
"availability": "https://schema.org/InStock",
"url": "https://lotuscab.com/pune-to-nashik-cab-service"
}
};












  return (
    <div>
      

<Helmet>
  <title>Pune to Nashik Cab Service | One Way & Round Trip Taxi | +91 8767592195</title>

<meta
 name="description"
 content="Book Pune to Nashik Cab Service with Lotus Cab at affordable fares. One way and round trip taxi service with Sedan, SUV, and AC cabs, experienced drivers, instant booking, and 24x7 customer support."
/>

<meta
 name="keywords"
 content="Pune to Nashik Cab Service, Pune to Nashik Cab, Pune to Nashik Taxi, Pune to Nashik Taxi Service, Nashik Cab from Pune, One Way Cab Pune to Nashik, Round Trip Cab Pune to Nashik, Outstation Cab Pune to Nashik, Pune to Trimbakeshwar Cab, Pune to Sula Vineyards Cab, Affordable Pune to Nashik Cab, Cheap Pune to Nashik Taxi, Online Pune to Nashik Cab Booking, Sedan Cab Pune to Nashik, SUV Cab Pune to Nashik, Best Pune to Nashik Cab, Lotus Cab Pune"
/>

  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>

</Helmet>





 <section className="page-header">
      
      {/* Background Image */}
      <div
        className="page-header__bg"
        style={{
          backgroundImage:
            "url(../images/page-header-bg-1-1.jpg)",
        }}
      ></div>
      <div className="container">
        <div className="page-header__content">
        
          <h2 className="page-header__title"> {cardData.keyword}</h2>
        </div>
      </div>
    </section>


      








      <section>
        <div className="container-fluid" >
          <div className="row container-fluid">
            <div className="col-12 col-md-7 bg-foootr">
              <img src='/images/keyword/79.png' alt='img' className='img-fluid' />
              <h3 className="py-1"
                style={{
                  color: '#183765', // Red color for the title 
                  textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                  fontWeight: 'bold'
                }}


              >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
              <div className="topPlaces">
                <p className="sectionLead">{cardData.top}</p>

                {cardData.topPlaces.map((place, index) => (
                  <article key={index} className="placeCard" tabIndex="0">
                    <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                    <div className="placeBody">
                      <h4 className="placeTitle">{place.title}</h4>
                      <p className="placeDesc">{place.description}</p>
                    </div>

                    <span className="placeArrow" aria-hidden>›</span>
                  </article>
                ))}
              </div>
              <div className="services-section">
                {cardData.services.map((service, index) => (
                  <div key={index} className="service-row">
                    <div className="service-icon">
                      🚖
                    </div>
                    <div>
                      <h4 className="service-title">{service.name}</h4>
                      <p className="service-desc">{service.description}</p>
                    </div>
                  </div>
                ))}
              </div>


              <table className="table table-responsive Border-key my-2">
                <tbody className=' Border-key'>
                  {cardData.tableData.map((row, rowIndex) => (
                    <tr className='Border-key ' key={rowIndex}>
                      {row.map((cell, cellIndex) => (
                        <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                      ))}
                    </tr>
                  ))}
                </tbody>
              </table>
              {/* <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
              <BusRatesTable /> */}

              <div id="why-choose-section" className="why-choose-section">


                {/* Section Title */}
                <h2 className="section-title">
                  Why Choose <span>Lotus Cab</span>
                </h2>

                {/* Cards */}
                <div className="cards-grid">
                  {cardData.whychoose.map((item, index) => (
                    <div key={index} className="why-card">
                      <div className="icon-circle">{index + 1}</div>
                      <h4 className="card-heading">{item.WhyChooseheading}</h4>
                      <p className="card-desc">{item.WhyChoosedescription}</p>
                    </div>
                  ))}
                </div>
              </div>



              <div className="row twm-faq-section-1 m-b30">


                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                  <div className="twm-faq-info-wrap">

                    <div className="section-head left">
                      <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Lotus Cab </h2>
                    </div>


                    <div className="twm-faq-info">
                      <div className="accordion twm-acdn" id="sf-faq-accordion">

                        <FaqSection
                          title="Frequently Asked"
                          subtitle="Help & Info"
                          items={faqData}
                        />

                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <TestimonialSectionKeyword
                testimonials={testimonials}
              />


              <ContactShowcase />
            </div>

            <div className='col-12 col-md-4' >
              <div className="routeList">
                {Images.map((e, i) => {
                  const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                  const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                  return (
                    <a
                      key={e.link || i}
                      href={href}
                      className="routeItem"
                      aria-label={e.text}
                      {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                    >
                      <div className="routeThumb">
                        <img src={e.place} alt="" loading="lazy" />
                      </div>

                      <div className="routeMeta">
                        <h6 className="routeTitle">{e.text}</h6>
                        <span className="routeUnderline" />
                      </div>

                      <span className="routeArrow" aria-hidden>›</span>
                    </a>
                  );
                })}
              </div>




              <div>
                <FleetHighway />
              </div>
              <div className="pc-contact">
                <h4 className="pc-title">Contact Information</h4>

                <div className="pc-grid">
                  {/* Phones */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-telephone-fill"></i>
                      <span>Phone Numbers</span>
                    </header>

                    <div className="pc-list">
                      <a href="tel:+918767592195" className="pc-call">+91 8767592195</a>
                      <a href="tel:+919172145909" className="pc-call">+91 9172145909</a>
                    </div>

                    <div className="pc-cta">
                      <a
                        href="https://wa.me/918767592195"
                        target="_blank" rel="noopener noreferrer"
                        className="pc-whats"
                      >
                        <i className="bi bi-whatsapp me-1"></i> WhatsApp
                      </a>
                      <a href="tel:+918767592195" className="pc-primary">
                        Call Now
                      </a>
                    </div>
                  </section>

                  {/* Email */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-envelope-fill"></i>
                      <span>Email</span>
                    </header>

                    <a href="mailto:booking@lotuscab.com" className="pc-email">
                      booking@lotuscab.com
                    </a>
                  </section>

                  {/* Address */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-house-fill"></i>
                      <span>Address</span>
                    </header>

                    <address className="pc-address">
                      <strong>Lotus Cab </strong><br />
                    Mauli Krupa building,
                    Sant Tukaram Nagar Gali No.1,
                    Navi sangvi MK chauk -411027
                    </address>
                  </section>
                </div>
              </div>


            </div>
          </div>
        </div>
      </section>


    </div>
  );
}

export default Punetonashikcabservice;